import { Award } from '../types/award';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const AwardApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getAwards: build.query<any, void>({
      query: () => ({
        url: appEndpoint.awards,
        method: 'get',
      }),
      providesTags: ['Awards'],
    }),
    addAward: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.awards,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Awards"] : []),
    }),
    updateAward: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.awards}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Awards"] : []),
    }),
    getAwardById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.awards}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'awardDetail', id }],
    }),
    deleteAward: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.awards}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Awards'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAwardsQuery,
  useGetAwardByIdQuery,
  useDeleteAwardMutation,
  useUpdateAwardMutation,
  useAddAwardMutation,
} = AwardApi; 